export default {
  SORT_DISTANCE: 'distance',
  SORT_NAME: 'name',
  SORT_REL: 'rel',
  BOUNDARY_QUERY_ENABLED: 'enabled',
  BOUNDARY_QUERY_DISABLED: 'disabled',
};
